<template>
  <div>
    <div class="columns is-centered  is-vcentered has-background-dvodark">
      <div class="column is-half full">
            <h2 class="has-text-white">Confirm Sign Up</h2>
            <div class="field">
                <label class="label">Email:</label>
                <div class="control">
                  <input id="usernameInput" class="input has-text-white" type="text" autofocus v-model="username">
                </div>
            </div>
            <div class="field">
                  <label class="label">Code:</label>
                  <div class="control">
                    <input id="codeInput" class="input has-text-white" type="password" autofocus v-model="code">
                  </div>
            </div>
            <div class="buttons">
                  <button @click="confirmSignUp" class="button is-dvogreen">Submit</button>
                  <button @click="confirmResend" class="button is-dvogreen">Resend Code</button>
            </div>
      </div>
    </div>
    <div class="columns is-centered has-background-dvodark">
      <div class="column is-half">
        <v-alert />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import { mapGetters } from "vuex";
import router from "@/router";
import store from "@/store";

import Alert from "@/components/auth/Alert.vue";

Vue.component("v-alert", Alert);

export default {
  data() {
    return {
      username: "",
      code: ""
    };
  },
  computed: {
    ...mapGetters("auth", ["hasAuthenticationStatus"])
  },
  methods: {
    async confirmSignUp() {
      await store.dispatch("auth/confirmSignUp", {
        username: this.username,
        code: this.code
      }).then(async(res) => {
        if(res.status === "Success") {
          this.$buefy.notification.open({
                      duration: 5000,
                      message: `Sign Up Successful`,
                      position: 'is-bottom',
                      type: 'is-success',
                      hasIcon: true
        })
      }
      }).catch((e) => {
          this.$buefy.notification.open({
              duration: 5000,
              message: `${e}`,
              position: 'is-bottom',
              type: 'is-danger',
              hasIcon: true
          })
      })
      if (!this.hasAuthenticationStatus) {
        router.push({path: "/"});
      }
    },
    async confirmResend() {
      await store.dispatch("auth/confirmResend", {
        username: this.username
      });
    }
  }
};
</script>

<style>
.full{
  min-height: 80vh
}
</style>